import {useProductDetailContext} from '../contexts/ProductDetailContext';
import {useErrorLoadingState} from '../../helpers/hooks/useErrorLoadingState';
import {useEffect} from 'react';
import {ProductDetailsUI} from '../ui/ProductDetailsUI';

export const ProductDetails = ({ productCode }) => {
  const { productDetails, loadProductDetails } = useProductDetailContext();
  const { error, loading, run } = useErrorLoadingState();

  useEffect(() => {
    run(loadProductDetails, [productCode]);
  }, [loadProductDetails, productCode, run]);

  return (
    <ProductDetailsUI data={{
      details: productDetails,
      loading: loading,
      error: error
    }} />
  );
};